(function () {
  const Core = window.RB.Core;
  const Flow = window.RB.Flow;
  const Play = window.RB.Play;

  const owners = function (spec, p) {
    return spec.enemy ? [Core.otherPlayer(p)] : spec.anyPlayer ? [0, 1] : [p];
  };

  const fromPlayerLists = function (key) {
    return function (state, spec, ctx) {
      const out = [];
      for (const owner of owners(spec, ctx.p)) for (const iid of state.players[owner][key]) out.push(iid);
      return out;
    };
  };

  const CAND_POOLS = {
    board(state, spec, ctx) {
      return Core.boardObjs(state, function (o, iid) {
        if (o.attachedTo && !spec.attached) return false;
        if (!spec.type && !(Core.isType(state, iid, "unit") || Core.isType(state, iid, "gear") || Core.isType(state, iid, "rune"))) return false;
        return true;
      });
    },
    trash: fromPlayerLists("trash"),
    champion: fromPlayerLists("champion"),
    hand: fromPlayerLists("hand"),
    facedown(state, spec, ctx) {
      const out = [];
      for (const bfIid of state.battlefields) {
        for (const fd of Flow.hiddenAt(state, bfIid)) out.push(fd);
      }
      return out;
    },
    battlefield(state) { return state.battlefields.slice(); },
    legend(state, spec, ctx) {
      const out = [];
      for (const owner of owners(spec, ctx.p)) {
        const iid = state.players[owner].legendIid;
        if (iid) out.push(iid);
      }
      return out;
    },
  };

  const mightOf = function (state, iid) { return Core.effMight(state, iid); };

  const BIND_DEP_KEYS = ["lessMightThanBind", "atBind", "notAtBfBind", "attachedToBind", "isBind", "notBind", "notSameLocAs", "sameLocAs"];

  const CAND_FILTERS = {
    type(state, o, iid, spec) { return Core.isType(state, iid, spec.type); },
    notType(state, o, iid, spec) { return !Core.isType(state, iid, spec.notType); },
    hasKw(state, o, iid, spec) { return Core.hasKw(state, iid, spec.hasKw); },
    notHasKw(state, o, iid, spec) { return !Core.hasKw(state, iid, spec.notHasKw); },
    notTag(state, o, iid, spec) { return !Core.hasTag(state, iid, spec.notTag); },
    tag(state, o, iid, spec) { return Core.hasTag(state, iid, spec.tag); },
    domain(state, o, iid, spec) { return ((Core.card(state, iid) || {}).domains || []).indexOf(spec.domain) >= 0; },
    notDomain(state, o, iid, spec) { return ((Core.card(state, iid) || {}).domains || []).indexOf(spec.notDomain) < 0; },
    token(state, o) { return !!o.token; },
    nonToken(state, o) { return !o.token; },
    sameName(state, o, iid, spec, ctx) {
      const src = ctx.srcObj || (ctx.item && ctx.item.iid && state.objs[ctx.item.iid]);
      if (!src) return false;
      return Core.name(state, iid) === Core.name(state, src.iid);
    },
    affordable(state, o, iid, spec, ctx) {
      if (Play.playRestricted(state, ctx.p, iid)) return false;
      if (!Play.requiredTargetsAvailable(state, ctx.p, iid, {})) return false;
      const probe = Play.probeItem(state, ctx.p, iid, { fromZone: ctx.zone });
      probe.flowPlayed = false;
      probe.fromZone = ctx.zone;
      const cost = Play.effectiveCost(state, probe, {});
      return Play.poolPotentialCovers(state, ctx.p, cost, Play.payCtxForCard(state, iid));
    },
    maxEnergy(state, o, iid, spec) { return (Core.card(state, iid).energy || 0) <= spec.maxEnergy; },
    maxPips(state, o, iid, spec) { return (Core.card(state, iid).power || 0) <= spec.maxPips; },
    maxEnergyVarLE(state, o, iid, spec, ctx) {
      const lim = (ctx.item && ctx.item.vars[spec.maxEnergyVarLE]) || 0;
      return (Core.card(state, iid).energy || 0) <= lim;
    },
    maxPipsVarLE(state, o, iid, spec, ctx) {
      const lim = (ctx.item && ctx.item.vars[spec.maxPipsVarLE]) || 0;
      return (Core.card(state, iid).power || 0) <= lim;
    },
    maxEnergyVar(state, o, iid, spec, ctx) {
      const lim = spec.maxEnergyVar === "points" ? state.players[ctx.p].points : (ctx.item && ctx.item.vars[spec.maxEnergyVar]) || 0;
      return (Core.card(state, iid).energy || 0) < lim;
    },
    chosenChampion(state, o, iid) { return (Core.card(state, iid) || {}).id === state.players[o.owner].chosenChampion; },
    friendly(state, o, iid, spec, ctx) { return ctx.zone === "facedown" ? o.owner === ctx.p : o.controller === ctx.p; },
    enemy(state, o, iid, spec, ctx) {
      if (ctx.zone !== "board" && ctx.zone !== "facedown") return true;
      return ctx.zone === "facedown" ? o.owner !== ctx.p : o.controller !== ctx.p;
    },
    atBf(state, o) { return !!(o.loc && o.loc.t === "bf"); },
    inBase(state, o) { return !!(o.loc && o.loc.t === "base"); },
    here(state, o, iid, spec, ctx) {
      const hereBf = ctx.item && ctx.item.ctx && ctx.item.ctx.bf;
      return !!(hereBf && o.loc && o.loc.t === "bf" && o.loc.iid === hereBf);
    },
    inCombat(state, o) { return !!o.designation; },
    isAttached(state, o) { return !!o.attachedTo; },
    hasAttachment(state, o) { return (o.attachments || []).length > 0; },
    isEvTarget(state, o, iid, spec, ctx) {
      const ev = ctx.item && ctx.item.ctx && ctx.item.ctx.ev;
      return !!(ev && (ev.targets || []).indexOf(iid) >= 0);
    },
    equipment(state, o, iid) {
      const sc = RB.Scripts.forCard(state, iid);
      return !!(sc && (sc.abilities || []).some(function (ab) { return ab.label === "Equip"; }));
    },
    inCombatWithDomain(state, o, iid, spec) {
      if (!o.designation) return false;
      return Core.boardObjs(state).some(function (u) {
        const uo = state.objs[u];
        if (!uo.designation || uo.controller === o.controller) return false;
        if (!Core.sameLoc(uo.loc, o.loc)) return false;
        return ((Core.card(state, u) || {}).domains || []).indexOf(spec.inCombatWithDomain) >= 0;
      });
    },
    chosenByEnemyDomain(state, o, iid, spec) {
      return (state.chain || []).some(function (it) {
        if (it.controller === o.controller || !it.iid) return false;
        if (((Core.card(state, it.iid) || {}).domains || []).indexOf(spec.chosenByEnemyDomain) < 0) return false;
        for (const b in it.targets || {}) if ((it.targets[b] || []).indexOf(iid) >= 0) return true;
        return false;
      });
    },
    atEvLoc(state, o, iid, spec, ctx) {
      const ev = ctx.item && ctx.item.ctx && ctx.item.ctx.ev;
      if (!ev) return false;
      const which = spec.atEvLoc;
      const hit = function (loc) { return !!(loc && o.loc && Core.sameLoc(o.loc, loc)); };
      if (which === "from") return hit(ev.from);
      if (which === "to") return hit(ev.to);
      return hit(ev.from) || hit(ev.to);
    },
    attacking(state, o) { return o.designation === "attacker"; },
    defending(state, o) { return o.designation === "defender"; },
    attachedToBind(state, o, iid, spec, ctx) {
      if (!ctx.item) return false;
      const anchor = (ctx.item.targets[spec.attachedToBind] || [])[0];
      return !!anchor && o.attachedTo === anchor;
    },
    other(state, o, iid, spec, ctx) {
      if (ctx.srcObj && iid === ctx.srcObj.iid) return false;
      return !(ctx.item && iid === ctx.item.iid);
    },
    maxMight(state, o, iid, spec) { return mightOf(state, iid) <= spec.maxMight; },
    minMight(state, o, iid, spec) { return mightOf(state, iid) >= spec.minMight; },
    ready(state, o, iid, spec) { return o.ready === spec.ready; },
    notHost(state, o, iid, spec, ctx) { return !(ctx.item && ctx.item.ctx && ctx.item.ctx.host === iid); },
    damaged(state, o) { return o.damage.length > 0; },
    stunned(state, o) { return !!o.stunned; },
    empowered(state, o) { return !!o.empowered; },
    notEmpowered(state, o) { return !o.empowered; },
    attachedToSource(state, o, iid, spec, ctx) {
      const src = ctx.srcObj || (ctx.item && ctx.item.iid && state.objs[ctx.item.iid]);
      return !!(src && o.attachedTo === src.iid);
    },
    notAtBfBind(state, o, iid, spec, ctx) {
      if (!ctx.item) return true;
      const anchor = (ctx.item.targets[spec.notAtBfBind] || [])[0];
      if (!anchor) return true;
      return !(o.loc && o.loc.t === "bf" && o.loc.iid === anchor);
    },
    maxEnergyAmt(state, o, iid, spec, ctx) {
      const lim = RB.FX.amount(state, ctx.item || { controller: ctx.p, targets: {}, vars: {} }, spec.maxEnergyAmt);
      return (Core.card(state, iid).energy || 0) <= lim;
    },
    lethal(state, o, iid) { return Core.lethal(state, iid); },
    lessMightThanSource(state, o, iid, spec, ctx) {
      const src = ctx.srcObj || (ctx.item && ctx.item.iid && state.objs[ctx.item.iid]);
      if (!src) return false;
      const a = Core.effMight(state, iid), b = Core.effMight(state, src.iid);
      return a !== null && b !== null && a < b;
    },
    unitsThere(state, o, iid, spec, ctx) {
      const n = Core.unitsAt(state, { t: "bf", iid: iid }, function (u) {
        if (spec.unitsThereWho === "friendly") return u.controller === ctx.p;
        if (spec.unitsThereWho === "enemy") return u.controller !== ctx.p;
        return true;
      }).length;
      const cmp = spec.unitsThereCmp || "exactly";
      if (cmp === "atLeast") return n >= spec.unitsThere;
      if (cmp === "atMost") return n <= spec.unitsThere;
      return n === spec.unitsThere;
    },
    hasBuff(state, o) { return o.buffs > 0; },
    otherLoc(state, o, iid, spec, ctx) { return !(ctx.srcObj && Core.sameLoc(o.loc, ctx.srcObj.loc)); },
    notSameLocAs(state, o, iid, spec, ctx) {
      if (!ctx.item) return true;
      const anchor = (ctx.item.targets[spec.notSameLocAs] || [])[0];
      const ao = anchor && state.objs[anchor];
      return !(ao && Core.sameLoc(o.loc, ao.loc));
    },
    sameLocAs(state, o, iid, spec, ctx) {
      if (!ctx.item) return true;
      const anchor = (ctx.item.targets[spec.sameLocAs] || [])[0];
      const ao = anchor && state.objs[anchor];
      return !!(ao && Core.sameLoc(o.loc, ao.loc));
    },
    namedTag(state, o, iid, spec, ctx) {
      const src = ctx.srcObj;
      if (!src || !src.named || src.named.kind !== "tag") return false;
      return Core.hasTag(state, iid, src.named.value);
    },
    notBind(state, o, iid, spec, ctx) { return !(ctx.item && (ctx.item.targets[spec.notBind] || []).indexOf(iid) >= 0); },
    notEv(state, o, iid, spec, ctx) {
      const ev = ctx.item && ctx.item.ctx && ctx.item.ctx.ev;
      return !(ev && ev.iid === iid);
    },
    isBind(state, o, iid, spec, ctx) { return !!(ctx.item && (ctx.item.targets[spec.isBind] || []).indexOf(iid) >= 0); },
    lessMightThanBind(state, o, iid, spec, ctx) {
      if (!ctx.item) return false;
      const anchor = (ctx.item.targets[spec.lessMightThanBind] || [])[0];
      if (!anchor) return false;
      const a = Core.effMight(state, iid), b = Core.effMight(state, anchor);
      return a !== null && b !== null && a < b;
    },
    atBind(state, o, iid, spec, ctx) {
      if (!ctx.item) return false;
      const anchor = (ctx.item.targets[spec.atBind] || [])[0];
      if (!anchor) return false;
      if (state.battlefields.indexOf(anchor) >= 0) {
        return !!(o.loc && o.loc.t === "bf" && o.loc.iid === anchor);
      }
      const ao = state.objs[anchor];
      return !!(ao && ao.loc && Core.sameLoc(o.loc, ao.loc));
    },
  };

  function chainCandidates(state, spec, item, p) {
    const out = [];
    for (const it of state.chain) {
      if (spec.kinds ? spec.kinds.indexOf(it.kind) < 0 : (spec.type === "spell" && it.kind !== "spell")) continue;
      if (spec.enemy && it.controller === p) continue;
      if (item && it.id === item.id) continue;
      const all = Core.itemTargets(it);
      if (spec.targetsMatching) {
        const pool = Play.candidates(state, Object.assign({ ignoreUntargetable: true }, spec.targetsMatching), item);
        if (!all.some(function (t) { return pool.indexOf(t) >= 0; })) continue;
        if (spec.targetsOnlyMatching && !all.every(function (t) { return pool.indexOf(t) >= 0; })) continue;
      }
      if (spec.targetsNoneMatching) {
        const bad = Play.candidates(state, Object.assign({ ignoreUntargetable: true }, spec.targetsNoneMatching), item);
        if (all.some(function (t) { return bad.indexOf(t) >= 0; })) continue;
      }
      if ((spec.maxEnergy !== undefined || spec.maxPips !== undefined) && it.iid) {
        const cc = Core.card(state, it.iid);
        if (spec.maxEnergy !== undefined && (cc.energy || 0) > spec.maxEnergy) continue;
        if (spec.maxPips !== undefined && (cc.power || 0) > spec.maxPips) continue;
      }
      out.push("chain:" + it.id);
    }
    return out;
  }

  Object.assign(Play, {
    candidates(state, spec, item, opts) {
      if (spec.orSpecs) {
        const seen = {};
        const merged = [];
        for (const sub of spec.orSpecs) {
          for (const iid of Play.candidates(state, sub, item, opts)) {
            if (!seen[iid]) { seen[iid] = 1; merged.push(iid); }
          }
        }
        return merged;
      }
      const p = item ? item.controller : spec.controller;
      const zone = spec.zone || "board";
      if (zone === "chain") return chainCandidates(state, spec, item, p);
      const pool = CAND_POOLS[zone];
      if (!pool) return [];
      const itemFd = item && (item.fromFacedown || (item.ctx && item.ctx.fromFacedown));
      const itemFdBf = item && (item.hiddenBf || (item.ctx && item.ctx.hiddenBf));
      const ctx = {
        p: p, item: item, zone: zone,
        srcObj: item && item.source ? state.objs[item.source] : null,
        restrictBf: !(opts && opts.ignoreHiddenBf) && itemFd && itemFdBf && zone === "board" ? itemFdBf : null,
      };
      const out = [];
      for (const iid of pool(state, spec, ctx)) {
        const o = state.objs[iid];
        let ok = true;
        for (const key in spec) {
          const pred = CAND_FILTERS[key];
          if (!pred || spec[key] === undefined || (spec[key] === false && key !== "ready")) continue;
          if (!pred(state, o, iid, spec, ctx)) { ok = false; break; }
        }
        if (!ok) continue;
        if (zone === "board" && ctx.restrictBf && (!o.loc || o.loc.t !== "bf" || o.loc.iid !== ctx.restrictBf)) continue;
        if (zone === "board" && !spec.ignoreUntargetable && Core.untargetableBy(state, iid, p)) continue;
        out.push(iid);
      }

      if (!out.length && ctx.restrictBf) {
        return Play.candidates(state, spec, item, { ignoreHiddenBf: true });
      }
      return out;
    },

    specsSatisfiable(state, specs, probe) {
      for (const entry of specs) {
        const spec = entry.spec || entry;
        const min = entry.min !== undefined ? entry.min : 1;
        if (spec.maxEnergyVarLE || spec.maxPipsVarLE) continue;
        let dep = null;
        for (const k of BIND_DEP_KEYS) {
          if (typeof spec[k] === "string") { dep = spec[k]; break; }
        }
        if (dep && !probe.targets[dep]) continue;
        let cands;
        if (dep && probe.targets[dep].length > 1) {
          const all = probe.targets[dep];
          const seen = {};
          cands = [];
          for (const anchor of all) {
            probe.targets[dep] = [anchor];
            for (const t of Play.candidates(state, spec, probe)) {
              if (!seen[t]) { seen[t] = 1; cands.push(t); }
            }
          }
          probe.targets[dep] = all;
        } else {
          cands = Play.candidates(state, spec, probe);
        }
        if (min > 0 && cands.length < min) return false;
        if (entry.bind) probe.targets[entry.bind] = cands;
      }
      return true;
    },

    chainNarrowedCandidates(state, specs, idx, item, cands) {
      const entry = specs[idx];
      const bind = entry.bind;
      if (!bind || !cands.length) return cands;
      if ((entry.max !== undefined ? entry.max : 1) !== 1) return cands;
      const rest = specs.slice(idx + 1);
      if (!rest.length) return cands;
      let coupled = false;
      for (const later of rest) {
        const s = later.spec || later;
        for (const k of BIND_DEP_KEYS) {
          if (s[k] === bind) { coupled = true; break; }
        }
        if (coupled) break;
      }
      if (!coupled) return cands;
      const keep = [];
      for (const c of cands) {
        const probe = {
          controller: item.controller, iid: item.iid, source: item.source,
          targets: {}, vars: item.vars || {}, ctx: item.ctx || {},
          fromFacedown: item.fromFacedown, hiddenBf: item.hiddenBf,
        };
        for (const b in item.targets || {}) probe.targets[b] = item.targets[b];
        probe.targets[bind] = [c];
        if (Play.specsSatisfiable(state, rest, probe)) keep.push(c);
      }
      return keep;
    },

    requiredTargetsAvailable(state, p, iid, opts) {
      if (!Core.isType(state, iid, "spell")) return true;
      const script = RB.Scripts.forCard(state, iid);
      if (!script || !script.targets || !script.targets.length) return true;
      opts = opts || {};
      const probe = {
        controller: p, iid: iid, targets: {}, vars: {}, ctx: {},
        fromFacedown: opts.fromFacedown, hiddenBf: opts.hiddenBf,
      };
      return Play.specsSatisfiable(state, script.targets, probe);
    },

    abilityTargetsAvailable(state, p, iid, ab) {
      if (!ab.targets || !ab.targets.length) return true;
      const src = state.objs[iid];
      const probe = {
        controller: p, iid: null, source: iid, targets: {}, vars: {},
        ctx: { bf: src && src.loc && src.loc.t === "bf" ? src.loc.iid : null },
      };
      return Play.specsSatisfiable(state, ab.targets, probe);
    },
  });
})();
